<form [formGroup]="form">
  <p-card header="Load Information">
    <div class="p-grid">
      <div class="form-group p-col-12 p-xl-6">
        <label [class.required]="supplierBOLRequired" for="supplierBOLNum">Supplier BOL Number</label>
        <div class="p-inputgroup">
          <input formControlName="vendorBolNumber" id="vendorBolNumber" pInputText type="text"/>
          <button (click)="getBolNumber()" [disabled]="requestingBolNumber"
                  [icon]="requestingBolNumber ? 'pi pi-spin pi-spinner' : ''" id="genbol" label="Generate"
                  pButton type="button"></button>
        </div>
        <error-block
          [field]="form.controls.vendorBolNumber"
          [messages]="{
            required: 'Supplier BOL Number is required.',
            numberInUse: 'Reference # is already in use.'
          }">
        </error-block>
      </div>
      <div class="form-group p-col-12 p-xl-6">
        <label class="required" for="trailerId">Trailer</label>
        <app-trailer-select
          inputId="trailerId"
          name="trailerId"
          formControlName="trailerId"
          eligibleFor="unloading"
          [siteSubinventoryId]="(_load | async)?.siteSubinventoryId"
          [carrier]="(_load | async)?.carrier">
        </app-trailer-select>
        <error-block [field]="form.controls.trailerId" [messages]="{
          required: 'Trailer is required.'
        }">
        </error-block>
      </div>
    </div>
    <div class="p-grid">
      <div class="form-group p-col-12 p-xl-6">
        <label class="required">Shift Unloaded</label>
        <app-worked-shift-selector
          [disabled]="form.disabled"
          formControlName="unloadedShiftId">
        </app-worked-shift-selector>
        <error-block
          [field]="form.controls.unloadedShiftId"
          [messages]="{
            required: 'Unloaded Shift is required.'
          }">
        </error-block>
      </div>

      <div class="form-group p-col-12 p-xl-6">
        <label class="required" for="unloadedTime">Date/Time Unloaded</label>
        <div class="p-inputgroup">
          <p-calendar formControlName="unloadedDate" inputId="unloadedDate" name="unloadedDate" appendTo="body"></p-calendar>
          <time-entry formControlName="unloadedTime" inputId="unloadedTime" [timezone]="siteTimezone" [displaySeconds]="false"></time-entry>
        </div>
        <error-block
          [field]="form.controls.unloadedDate"
          [messages]="{
            required: 'Date Unloaded is required.'
          }"></error-block>
        <error-block
          [field]="form.controls.unloadedTime"
          [messages]="{
            required: 'Time Unloaded is required.'
          }"></error-block>
        <error-block
          [field]="form"
          [messages]="{
            timeSequence: 'Unload Time must be after Check-in Time.',
            datediff: 'Unload Timestamp must be on same day as Unload Shift'
          }"></error-block>
      </div>
    </div>

    <div class="p-grid" *ngIf="showFullWorkflow">
      <div class="form-group p-col-12 p-xl-6">
        <label class="required">Shift Processed</label>
        <app-worked-shift-selector
          [disabled]="form.disabled"
          formControlName="processedShiftId">
        </app-worked-shift-selector>
        <error-block
          [field]="form.controls.processedShiftId"
          [messages]="{
            required: 'Processed Shift is required.'
          }">
        </error-block>
        <error-block
          [field]="form"
          [messages]="{
            shiftSequence: 'Processed Shift must be after Unloaded Shift.'
          }">
        </error-block>
      </div>
    </div>
  </p-card>

  <p-card>
    <p-table [paginator]="true" [rows]="10" [value]="form.controls.inboundLoadLineItems.controls" dataKey="id" editMode="row">
      <ng-template pTemplate="header">
        <tr>
          <th>Product</th>
          <th class="quantityTh">Quantity</th>
          <th>Product Description</th>
          <th class="deleteTh">Delete</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-ri="rowIndex" let-item>
        <tr [formGroup]="item">
          <td>
            <p-dropdown #productId
              formControlName="productId"
              [editable]="false"
              [filter]="true"
              [options]="productSelects | async"
              [resetFilterOnHide]="true"
              appendTo="body"
              name="product"
              (onHide)="productId.focus()">
            </p-dropdown>
          </td>
          <td>
            <input type="text" pInputText
              required
              name="quantity"
              formControlName="quantity"
              lib-numeric>
          </td>
          <td>
            <input pInputText type="text"
              formControlName="palletDescription"
              name="palletDescription">
          </td>
          <td>
            <confirmation-button
              (actionConfirmed)="deleteLineItem(ri)"
              [disabled]="form.disabled"
              [iconsOnly]="true"
              actionText="Delete" actionIcon="pi pi-times"
              cancelText="Cancel" cancelIcon="pi pi-minus-circle"
              confirmText="Delete" confirmIcon="pi pi-times">
            </confirmation-button>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="5" class="centered">
            No data available
          </td>
        </tr>
      </ng-template>
      <ng-template let-rowData pTemplate="footer">
        <tr [formGroup]="newLineForm">
          <td>
            <p-dropdown #newProductId
              [editable]="false"
              [filter]="true"
              [options]="productSelects | async"
              [readonly]="!(productSelects | async)?.length"
              [resetFilterOnHide]="true"
              appendTo="body"
              class="form-control"
              formControlName="productId"
              inputId="productId"
              name="product"
              (onHide)="newProductId.focus()"
              placeholder="-- Select Product --">
            </p-dropdown>
            <error-block [field]="newLineForm.controls.productId" [messages]="{
              required: 'Product is required.'
            }"></error-block>
          </td>
          <td>
            <input pInputText type="number"
              class="form-control" formControlName="quantity" id="quantity"
              lib-numeric name="quantity" required />
            <error-block [field]="newLineForm.controls.quantity" [messages]="{
              required: 'Quantity is required.',
              min: 'Quantity must be greater than 0.',
              max: 'Quantity is to high for the selected product.'
            }">
            </error-block>
          </td>
          <td>
            <input class="form-control" formControlName="palletDescription" id="palletDescription"
                  name="palletDescription" pInputText
                  type="text"/>
            <error-block [field]="newLineForm.controls.palletDescription" [messages]="{
              required: 'Description is required.'
            }">
            </error-block>
          </td>

          <td>
            <button (click)="addLineItem()" [disabled]="newLineForm.disabled"
                    [ngClass]="{ 'p-state-disabled': !newLineForm.valid }" icon="pi pi-plus" iconPos="left"
                    label="Add"
                    pButton
                    type="button"></button>
          </td>
        </tr>
        <tr>
          <td></td>
          <td class="centered">
            <data [value]="itemsTotal | async"
              class="total-quantity"
              aria-label="Total Quantity">
              Total: {{(itemsTotal | async).toLocaleString()}}
            </data>
          </td>
          <td></td>
          <td></td>
        </tr>
      </ng-template>
    </p-table>

    <error-block [field]="form.controls.inboundLoadLineItems" [messages]="{
        lineItemsExist: 'Load must have one or more line items.'
      }"></error-block>
  </p-card>

  <p-card header="Exceptions">
    <div class="p-grid">
      <div class="form-group p-col-3">
        <label for="isRejected">Site Rejected</label>
        <p-checkbox [binary]="true" formControlName="isRejected" inputId="isRejected" name="isRejected">
        </p-checkbox>
      </div>
      <div class="form-group p-col-9" *ngIf="form.controls.isRejected.value">
        <label for="rejectedBolNumber">Rejected BOL Number</label>
        <input formControlName="rejectedBolNumber" id="rejectedBolNumber" name="rejectedBolNumber" pInputText type="text"/>
      </div>
    </div>
    <div class="p-grid">
      <div *ngIf="form.controls.isRejected.value" class="p-col-12">
        <p-message severity="warn" text="Only use this if load is from your site."></p-message>
      </div>
    </div>
    <div class="p-grid">
      <div class="form-group p-col-3">
        <label for="redTagFlag">Red Tag</label>
        <p-checkbox [binary]="true" formControlName="redTagFlag" inputId="redTagFlag" name="redTagFlag"></p-checkbox>
      </div>
      <div class="form-group p-col-9" *ngIf="form.controls.redTagFlag.value">
        <label for="redTagReason">Reason</label>
        <input formControlName="redTagReason" id="redTagReason" name="redTagReason" pInputText type="text"/>
      </div>
    </div>
  </p-card>

  <div class="form-buttons">
    <button pButton type="submit"
      [label]="showFullWorkflow ? 'Process Load ' : 'Unload Load '"
      [icon]="updating ? 'pi pi-spin pi-spinner' : 'pi pi-arrow-right'"
      [disabled]="updating"
      (click)="processLoad()"
      [ngClass]="{'p-state-disabled': !form.valid, 'p-button-success': true }">
    </button>
  </div>
</form>
